<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <table class="table ">
          <thead>
          <tr>
            <th scope="col">ID</th>
            <th scope="col">{{ $trans.user.name }}</th>
            <th scope="col">{{ $trans.user.login }}</th>
            <th scope="col">
              <button class="btn btn-success" @click="$router.push({name: 'UserNew'})">{{ $trans.main.button_add_user }}</button>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="user in users">
            <td @click="editUser(user)">{{ user.id }}</td>
            <td @click="editUser(user)">{{ user.name }}</td>
            <td @click="editUser(user)">{{ user.login }}</td>
            <td>
              <button class="btn btn-info" @click="deleteUser(user)">{{ $trans.main.button_delete }}</button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="clearfix btn-group col-md-2 offset-md-5">
      <button type="button" class="btn btn-sm btn-outline-secondary" v-if="page != 1" @click="page--"> <<</button>
      <button type="button" class="btn btn-sm btn-outline-secondary" v-for="pageNumber in pages.slice(page-1, page+5)"
              @click="page = pageNumber"> {{ pageNumber }}
      </button>
      <button type="button" @click="page++" v-if="page < pages.length" class="btn btn-sm btn-outline-secondary"> >>
      </button>
    </div>
  </div>

</template>

<script>
import axios from 'axios'

export default {
  name: 'LocalUsers',
  data () {
    return {
      users: [],
      page: 1,
      filters: {
        date: ''
      },
      pages: []
    }
  },
  watch: {
    page () {
      this.getUsers()
    }
  },
  created () {
    this.getUsers()
  },
  methods: {
    async deleteUser (user) {
      axios({
        url: 'users/' + user.id,
        method: 'DELETE'
      }).then(response => {
        this.getUsers()
      }).catch(error => {
        console.log(error.response.data)
      })
    },
    async getUsers () {
      return new Promise((resolve, reject) => {
        axios({
          url: 'users',
          params: {filters: this.filters, page: this.page},
          method: 'GET'
        }).then(response => {
          this.users = response.data.users.data
          this.page = response.data.users.current_page
          let maxPage = Math.ceil(response.data.users.total / response.data.users.per_page)
          this.pages = []
          for (let i = 1; i <= maxPage; i++) this.pages.push(i)
        }).catch(error => {
          console.log(error.response.data)
        })
      })
    },
    editUser (user) {
      let id = user.id
      this.$router.push({name: 'UserEdit', params: {id: id}})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/users/Users.vue